'use client'

import { ArrowLeft24 } from '@vinted/monochrome-icons'
import { Button } from '@vinted/web-ui'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useInboxNavigator } from '@marketplace-web/messaging/navigation-feature'

const ConversationHeaderLeftAction = () => {
  const breakpoints = useBreakpoint()
  const inboxNavigator = useInboxNavigator()

  if (!breakpoints.portables) return null

  return (
    <Button
      styling="flat"
      theme="amplified"
      inline
      iconName={ArrowLeft24}
      testId="back-button"
      onClick={() => inboxNavigator.navigate()}
    />
  )
}

export default ConversationHeaderLeftAction
